import React, { useEffect } from "react";
import ScreenSelector from "@icarius-common/screenSelector";
import paths from "@icarius-router/paths";
import { getQuantityPerScreenAction } from "../actions";
import { useDispatch, useSelector } from "react-redux";
import { RESET_STATE } from "../actionTypes";
import { getQuantityPerScreen } from "../selectors";
import {
  AssetsAndDiscountsCreationIcon,
  AssetsAndDiscountsEntryPerConceptIcon,
  AssetsAndDiscountsEntryPerConceptSetIcon,
  AssetsAndDiscountsSummaryIcon,
  AssetsAndDiscountsEntryPerSocietyIcon,
  AssetsAndDiscountsEntryInInstallmentsIcon,
  MassEntryIcon,
  ImportIcon,
  DataCaptureIcon
} from "@icarius-icons/";
import { getLocalizedString } from "@icarius-localization/strings";

const AssetsAndDiscountsScreenSelector = () => {

  const dispatch = useDispatch();
  const quantityPerScreen = useSelector(getQuantityPerScreen)

  useEffect(() => {
    dispatch(getQuantityPerScreenAction());

    return () => {
      dispatch({ type: RESET_STATE });
    }
  }, [dispatch]);

  const data = [
    {
      name: getLocalizedString("entryPerConcept"),
      icon: <AssetsAndDiscountsEntryPerConceptIcon />,
      path: paths.entryPerConcept,
      amount: quantityPerScreen["Ingreso por concepto"]
    },
    {
      name: getLocalizedString("entryPerConceptSet"),
      icon: <AssetsAndDiscountsEntryPerConceptSetIcon />,
      path: paths.entryPerConceptSet,
      amount: quantityPerScreen["Ingreso por conjunto de conceptos"],
    },
    {
      name: getLocalizedString("entryPerSociety"),
      icon: <AssetsAndDiscountsEntryPerSocietyIcon />,
      path: paths.entryPerSociety,
      amount: quantityPerScreen["Ingreso por sociedad"],
    },
    {
      name: getLocalizedString("incomeInInstallments"),
      icon: <AssetsAndDiscountsEntryInInstallmentsIcon />,
      path: paths.entryInInstallments,
      amount: quantityPerScreen["Ingreso en cuotas"],
    },

    {
      name: getLocalizedString("massEntry"),
      icon: <MassEntryIcon />,
      path: paths.massEntry,
      amount: quantityPerScreen["Masivo"],
    },
    {
      name: getLocalizedString("entryByImport"),
      icon: <ImportIcon />,
      path: paths.entryByImport,
    },
    {
      name: getLocalizedString("dataEntryViaApi"),
      icon: <DataCaptureIcon />,
      path: paths.dataCapture,
      amount: quantityPerScreen["Vía captura desde otro sistema (API)"],
    },
    {
      name: getLocalizedString("assetsDiscountsSummary"),
      icon: <AssetsAndDiscountsSummaryIcon />,
      path: paths.assetsDiscountsSummary,
      amount: quantityPerScreen["Visualización de resumen"],
    },
    {
      name: getLocalizedString("assetsAndDiscountsCreation"),
      icon: <AssetsAndDiscountsCreationIcon />,
      path: paths.createAssetsDiscounts,
      amount: quantityPerScreen["Creación de haberes y descuentos"],
    },
  ];

  return (
    <ScreenSelector
      title={getLocalizedString("assetsAndDiscountsScreenSelector")}
      data={data}
    />
  );
}

export default AssetsAndDiscountsScreenSelector;
